import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            用户热评
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            听听黄桃视频的用户们怎么说
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {commentsData.map((comment, idx) => (
              <div
                key={idx}
                className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200 hover:shadow-sm transition-all duration-200"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-background-200">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        const target = e.currentTarget;
                        target.style.display = 'none';
                      }}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <span className="text-sm font-medium text-foreground-900 truncate">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                        {comment.time}
                      </span>
                    </div>
                    <div className="flex items-center gap-0.5 mb-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {comment.text}
                    </p>
                    <div className="flex items-center gap-1.5 mt-3 text-xs text-foreground-400">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}